<template>
  <div v-if="pageDevice != null && isLoginUserPageItemReadable">

    <deviceTabs v-if="isLoginUserPageItemReadable" :current="'intro'" :pageDevice="pageDevice" :pageUser="pageUser">

      <b-button v-if="!pageDevice.disabled && isLoginUserPageItemWritable" @click="updateDeviceInfo" size="sm"
        class="displayNoneMax589 float-right tabButton" variant="danger"
        :disabled="!this.pageBinded || this.pageDevice.disabled || submitDisabled">
        <b-spinner small type="grow" class="mr-1" v-if="showUpdateSpinner"></b-spinner>
        기본설정 저장하기
      </b-button>

    </deviceTabs>

    <div :class="(isLoginUserPageItemWritable)? 'writable':'notWritable'">

      <div v-if="isLoginUserPageItemWritable">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="pageDevice.disabled">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>

      <b-form @submit.stop.prevent class="was-validated">

        <h4 class="border-bottom mt-3 pt-1 pb-1">
          기본 정보
        </h4>

        <b-input-group size="sm" class="mt-2">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0">ID</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop readonly disabled :placeholder="this.pageDevice.id" />
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="pageDevice.creation">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label style="margin-bottom : 0rem">기기 만든 시간</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop readonly disabled
            :placeholder="dateToString(this.pageDevice.creation.toDate())" />
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="pageDevice.lastModified">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">기기 최종 수정</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop readonly disabled
            :placeholder="dateToString(this.pageDevice.lastModified.toDate())" />
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">데이터 최종 갱신</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop readonly disabled
            :placeholder="deviceSensorsLastModifiedDateString(pageDevice)" />
        </b-input-group>

        <div class="mt-1 gothic gridColumn">
          <div class="gridColumnTitle pt-2">데이터 줄 수</div>
          <div class="gridColumnBody">
            <ul class="m-0 ml-3 p-0">
              <li v-for="(item) in pageDevice.sensors" :key="item.id">
                <router-link :to="{ name: 'tinkSensor', params: { sid: item.id } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{item.title}}
                  </span>
                </router-link>:
                {{(item.lastBook*1000 + item.lastIndex + 1).toLocaleString("ko-KR")}} 줄
              </li>
              <li v-if="pageDeviceSensorsLength ==0">
                없음
              </li>
            </ul>
          </div>
        </div>

        <div class="mt-1 gothic gridColumn">
          <div class="gridColumnTitle">저장 데이터 크기</div>
          <div class="gridColumnBody">
            줄 수: {{this.totalDataRowCount.toLocaleString("ko-KR")}} 개 /
            칸 수: {{this.totalDataCellCount.toLocaleString("ko-KR")}} 개 /
            바이트: {{this.totalDataCellByteCount.toLocaleString("ko-KR")}} MByte
          </div>
        </div>

        <h4 class="border-bottom mt-3 pt-1 pb-1">
          기본 설정
        </h4>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceName" style="margin-bottom : 0rem">기기 이름</label>
          </b-input-group-text>
          <b-form-input v-model="pageDevice.name" id="deviceName" v-b-tooltip.focus title="기기의 이름입니다.
          최소 2글자 이상 최대 16글자입니다.
          보기에는 10글자 정도가 적당합니다." v-on:keyup="enterKeyChecker" data-nextfocus="deviceMacAddress" minlength="2"
            maxlength="16" required trim :disabled="!isLoginUserPageItemWritable" />
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceDescription" style="margin-bottom : 0rem">기기 설명</label>
          </b-input-group-text>
          <b-form-textarea v-touch:swipe.stop rows="3" max-rows="8" v-model="pageDevice.description"
            id="deviceDescription" v-b-tooltip.focus title="기기 설명입니다. 최대 250글자입니다. HTML 코드도 가능합니다." maxlength="210"
            style="overflow-y: hidden" trim :disabled="!isLoginUserPageItemWritable" required></b-form-textarea>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceMacAddress" style="margin-bottom : 0rem">MAC 주소</label>
          </b-input-group-text>
          <b-form-input v-model="pageDevice.macAddress" id="deviceMacAddress" v-b-tooltip.focus title="기기의 MAC 주소입니다."
            v-on:keyup="enterKeyChecker" data-nextfocus="deviceUseMacAddress" trim :disabled="!isLoginUserPageItemWritable" />
        </b-input-group>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="devicePhotoURL" style="margin-bottom : 0rem">기기 사진</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop type="url" v-model="pageDevice.photoURL" v-b-tooltip.focus
            title="목록에 표시할 기기의 사진 주소를 입력해주세요. 사진의 주소는 http://나 https://로 시작해야합니다." v-on:keyup="enterKeyChecker"
            data-nextfocus="deviceActive" id="devicePhotoURL" :disabled="!isLoginUserPageItemWritable" />
          <b-input-group-append
            v-if="isLoginUserPageItemWritable && (pageDevice.photoURL!= ''||showLocationInfoPhotos)">
            <b-button variant="secondary" v-b-tooltip.hover
              title="위치 정보가 등록된 경우에는 해당 위치 정보로 등록된 구글 사진을 가져와서 추천 사진으로 표시합니다." v-b-toggle.photosCollapse>사진보기</b-button>
          </b-input-group-append>
        </b-input-group>

        <div class="m-1" v-if="!this.isLoginUserPageItemWritable && this.pageDevice.photoURL != ''">
          <div style="float: left; position: relative">
            <b-img id="devicePhotoPreview" :src="pageDevice.photoURL" style="max-width: 26ex; float: left;"
              class="m-2" />
            <b-badge variant="primary" pill style="position: absolute; top: 2ex; left: 2ex;"
              class="p-1 pl-2 pr-2">사용중</b-badge>
          </div>
        </div>

        <b-collapse id="photosCollapse" class="mb-4 ml-2">
          <div v-if="pageDevice.photoURL != ''" style="float: left; position: relative">
            <b-img id="devicePhotoPreview" :src="pageDevice.photoURL" style="max-width: 26ex; float: left;"
              class="m-2" />
            <b-badge variant="primary" pill style="position: absolute; top: 2ex; left: 2ex;"
              class="p-1 pl-2 pr-2">사용중</b-badge>
          </div>
          <div v-if="pageDevice.locationInfo != null">
            <template v-for="(value, key) in pageDevice.locationInfo.photos">
              <div :key="key" style="float: left; position: relative" v-if="key != pageDevice.photoURL">
                <b-img :src="key" style="max-width: 26ex;" class="m-2" />
                <b-button variant="secondary" size="sm" style="position: absolute; bottom: 2ex; right: 2ex;"
                  @click="applyDevicePhotoURL" :data-photourl="key">사용하기</b-button>
              </div>
            </template>
          </div>
        </b-collapse>

        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">기기 위치</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop type="text" v-if="isLoginUserPageItemWritable" 
            :value="geopointToLatLngString(pageDevice.location)" id="deviceLocation" v-b-tooltip.focus
            :title="geopointToLatLngString(pageDevice.location)" :disabled="!isLoginUserPageItemWritable"
            @blur="inputApplyGeopoint" v-on:keyup="enterKeyChecker" data-nextfocus="locationZoom" trim />

          <b-form-input v-touch:swipe.stop v-else type="text" style="color: #0004af;"
            :value="geopointToLatLngString(pageDevice.location)" disabled data-nextfocus="locationZoom" trim />
          <b-input-group-append v-if="isLoginUserPageItemWritable">
            <b-button tab-index="-1" variant="outline-secondary" @click="deleteLocation">삭제</b-button>
            <b-button tab-index="-1" id="mapHelp" variant="outline-secondary">?</b-button>
            <b-button variant="secondary" v-b-toggle.gmapCollapse @click="initGmap">지도</b-button>
          </b-input-group-append>
          <b-input-group-append v-else>
            <b-button variant="secondary" @click="openNewGmapWindow">구글지도</b-button>
          </b-input-group-append>
        </b-input-group>

        <b-popover target="mapHelp" trigger="focus" v-if="isLoginUserPageItemWritable">
          <ul class="pl-3 pt-2">
            <li>기기 위치는 텍스트입력 칸에 {"lat": <i>[위도]</i>, "lng": <i>[경도]}</i>와 같은 JSON 형식으로 직접 입력해도 됩니다.</li>
            <li><i>[위도]</i>는 -90이상, 90이하 숫자입니다. <i>[경도]</i>는 -180이상 180이하 숫자입니다.</li>
            <li>지도를 누르면 그 위치로 마커가 이동하면서 기기 위치로 지정됩니다.</li>
            <li>기기 이름을 누르면 기기의 센서 데이타 표를 표시하거나 감출 수 있습니다.</li>
            <li>마커를 누르면 마커가 지도의 중심이 됩니다.</li>
            <li>+, - 버튼을 눌러서 지도를 확대 축소할 수 있습니다. 확대 축소 전에 마커를 누르면 마커를 중심으로 확대, 축소할 수 있습니다.</li>
            <li>기기 위치를 저장할 때 지도의 줌인 정도도 함께 저장되어 지도를 표시할 때 사용합니다.</li>
          </ul>
        </b-popover>

        <b-collapse id="gmapCollapse" class="mt-2" v-if="gmapInited">
          <GmapMap ref="gmap" :center="centerPosition" :zoom="pageDevice.locationZoom"
            style="width: 100%; height: 0; padding-bottom: 75%;" :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false,
              gestureHandling: 'auto'
            }" @click="clickPopup"></GmapMap>

          <div class="map-autocomplete-block" v-if="isLoginUserPageItemWritable" style="visibility: hidden"
            id="gmapAutoComplete">
            <!-- x5-gmaps -->
            <gmap-autocomplete ref="autocomplete" class="map-autocomplete" :value="gmapPlaceSearch"
              placeholder="장소를 입력하세요." :select-first-on-enter="true" @place_changed="setPlace" :options="{
                  'componentRestrictions': {country: 'kr'},
                  'fields': ['geometry','formatted_address', 'international_phone_number', 'name', 'place_id', 'website', 'photos']
                }" v-on:keydown.enter.prevent="doNothing" />
          </div>

          <div id="gmapTextSize" style="visibility: hidden">
            <div class="map-textsize-block">
              <div class="map-textsizeplus-text no-select" @click="mapTextSizePlus" title="글자 크기를 크게">T+</div>
              <hr />
              <div class="map-textsizeminus-text roboto no-select" @click="mapTextSizeMinus" title="글자 크기를 작게">T-</div>
            </div>
          </div>

          <div class="map-popup-block" id="gmapPopup" style="visibility: hidden;">
            <div class="map-popup-body">


              <div class="map-popup-title gothic no-select" v-b-toggle.gmapPopup-table>{{this.pageDevice.name}}</div>
              <b-collapse visible class="map-popup-collapse" id="gmapPopup-table">
                <div class="map-popup-content">
                  <div v-for="sensor in pageDevice.sensors" class="map-popup-sensor" :key="sensor.id">
                    <div v-if="sensor.lastValues != null">
                      <div v-for="(value, index) in sensor.lastValues.v"
                        class="map-popup-row d-flex flex-nowrap justify-content-between" :key="index">
                        <div class="map-popup-row-title gothic" v-html="sensor.values[index].title"></div>

                        <div class="map-popup-row-value gothic"
                          v-if="sensor.values[index].type == 'int' || sensor.values[index].type == 'number'"
                          v-html="value.toLocaleString('ko-KR')"></div>
                        <div class="map-popup-row-value gothic" v-else v-html="value"></div>

                        <div class="map-popup-row-unit gothic"
                          v-if="typeof(sensor.values[index].unit) != 'undefined' && sensor.values[index].unit !=''"
                          v-html="sensor.values[index].unit"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>

            <div class="map-popup-marker">
              <img src="@/assets/img/mapMarker2.png" @click="clickMarker" />
            </div>
          </div>


        </b-collapse>

        <b-input-group size="sm" class="mt-1" v-if="this.pageDevice.locationInfo">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">위치 정보</label>
          </b-input-group-text>
          <b-form-input v-model="this.pageDevice.locationInfo.name" id="locationInfo" v-on:keyup="enterKeyChecker"
            data-nextfocus="locationPopupFontSize" :disabled="!isLoginUserPageItemWritable" readonly />
          <b-button slot="append" variant="secondary" id="locationInfoButton">상세</b-button>
          <b-popover target="locationInfoButton" triggers="click">
            <template slot="title">{{this.pageDevice.locationInfo.name}}</template>
            <ul>
              <li v-if="this.pageDevice.locationInfo.formatted_address">주소:
                {{this.pageDevice.locationInfo.formatted_address}}</li>
              <li v-if="this.pageDevice.locationInfo.geometry && this.pageDevice.locationInfo.geometry.location">위치:
                ( {{this.pageDevice.locationInfo.geometry.location.lat}},
                {{this.pageDevice.locationInfo.geometry.location.lng}} )
              </li>
              <li v-if="this.pageDevice.locationInfo.international_phone_number">전화번호:
                {{this.pageDevice.locationInfo.international_phone_number}}</li>
              <li v-if="this.pageDevice.locationInfo.website">웹사이트: <a :href="this.pageDevice.locationInfo.website"
                  target="_new">{{this.pageDevice.locationInfo.website}}</a></li>
              <li v-if="this.pageDevice.locationInfo.place_id">PLACE ID: <a
                  :href="'https://www.google.com/maps/place/?q=place_id:' + this.pageDevice.locationInfo.place_id"
                  target="_new">{{this.pageDevice.locationInfo.place_id}}</a></li>
            </ul>
          </b-popover>
        </b-input-group>


        <b-input-group size="sm" class="mt-1" v-if="gmapInited">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">지도 줌인</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop v-model="this.pageDevice.locationZoom" id="locationZoom"
            v-on:keyup="enterKeyChecker" data-nextfocus="locationPopupFontSize" type="number" trim v-b-tooltip.focus
            title="지도의 줌인 정도입니다. 기기 정보를 저장할 때 줌인 정도가 자동 저장됩니다." :disabled="!isLoginUserPageItemWritable" readonly />
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="gmapInited">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">팝업 글자 크기</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop v-model="this.pageDevice.locationPopupFontSize" id="locationPopupFontSize"
            v-b-tooltip.focus v-on:keyup="enterKeyChecker" data-nextfocus="updateDeviceInfo" type="number" trim
            title="지도 안에 표시되는 팝업의 글자 크기입니다. 직접 수정할 수 없고 기기 정보를 저장할 때 글자 크기가 자동 저장됩니다."
            :disabled="!isLoginUserPageItemWritable" readonly />
        </b-input-group>


        <h4 class="border-bottom mt-3 pt-1 pb-1">
          기본 동작
        </h4>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceUseMacAddress" style="margin-bottom : 0rem">센서 목록 응답</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.useSensorsResponse" id="deviceUseSensorsResponse"
            :disabled="!isLoginUserPageItemWritable" required v-b-tooltip.focus
            title="센서 목록 응답을 사용으로 선택하면 기기에서 접속코드를 사용하여 센서 목록을 조회할 수 있습니다..">
            <option :value="true">사용</option>
            <option :value="false">사용안함</option>
          </b-form-select>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceUseMacAddress" style="margin-bottom : 0rem">MAC 주소 응답</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.useMacAddress" id="deviceUseMacAddress"
            :disabled="!isLoginUserPageItemWritable" required v-b-tooltip.focus
            title="MAC 주소 응답 사용을 선택하면 기기에서 MAC 주소로 접속 코드를  조회할 수 있습니다.">
            <option :value="true">사용</option>
            <option :value="false">사용안함</option>
          </b-form-select>
        </b-input-group>


        <b-input-group size="sm" class="mt-1">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceActive" style="margin-bottom : 0rem">데이터 업로드</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.active" id="deviceActive" :disabled="!isLoginUserPageItemWritable"
            v-b-tooltip.focus title="꺼짐이면 기기에서 보내는 업로드 데이터를 받지 않습니다.">
            <option :value="true">켜짐</option>
            <option :value="false">꺼짐</option>
          </b-form-select>
        </b-input-group>


        <h4 class="border-bottom mt-3 pt-1 pb-1" v-if="isLoginUserPageItemWritable">
          접근 권한
        </h4>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceAdmin" style="margin-bottom : 0rem" v-if="!adminEditing">관리자 ID</label>
            <label for="newAdminIdOrEmail" style="margin-bottom : 0rem" v-else>ID 또는 전자우편</label>
          </b-input-group-text>

          <b-form-input v-touch:swipe.stop v-model="pageDevice.admin" v-if="!adminEditing" readonly id="deviceAdmin"
            v-b-tooltip.focus :title="pageDevice.admin" v-on:keyup="enterKeyChecker" data-nextfocus="deviceName"
            minlength="28" maxlength="28" trim :disabled="!isLoginUserPageItemWritable" />

          <b-form-input v-touch:swipe.stop v-if="adminEditing" v-model="newAdminIdOrEmail" id="newAdminIdOrEmail"
            pattern="^|([^\s@]+@[^\s@]+\.[^\s@]{2,})|([a-zA-Z0-9]{28})$" trim minlength="0" maxlength="64"
            v-b-tooltip.focus :title="newAdminIdOrEmail" v-on:keyup="enterKeyChecker"
            data-nextfocus="newAdminIdOrEmailApplyButton" />

          <b-button v-if="adminEditing" variant="primary" slot="append" class="pl-2 pr-2"
            id="newAdminIdOrEmailApplyButton" @click="applyNewAdmin" :disabled="submitDisabled">
            적용
          </b-button>
          <b-button v-if="adminEditing" variant="secondary" class="pl-2 pr-2" @click="cancelEditAdmin" slot="append">
            취소
          </b-button>
          <b-button v-if="!adminEditing" variant="primary" class="pl-2 pr-2" @click="editAdmin" slot="append">
            수정
          </b-button>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceInherit" style="margin-bottom : 0rem">상속값 사용</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.inherit" id="deviceInherit" :disabled="!isLoginUserPageItemWritable"
            v-b-tooltip.focus
            title="사용이면 내 정보에서 공개 여부, 친구 목록을 수정하면 기기에도 자동 반영됩니다. 사용안함으로 설정하면 기기에서 공개 여부, 친구 목록을 수정할 수 있지만 내 정보에 수정된 내용은 반영되지 않습니다.">
            <option :value="true">사용</option>
            <option :value="false">사용안함</option>
          </b-form-select>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceInherit" style="margin-bottom : 0rem">공개 여부</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.open" id="deviceOpen"
            :disabled="!isLoginUserPageItemWritable || pageDevice.inherit" v-b-tooltip.focus
            title="공개로 지정하면 모든 로그인 사용자가 이 기기의 정보를 읽을 수 있고 공개안함으로 지정하면 등록된 친구만 기기의 정보를 읽을 수 있습니다.">
            <option :value="true">공개</option>
            <option :value="false">공개안함</option>
          </b-form-select>
        </b-input-group>

        <div class="mt-1 gothic gridColumn"
          v-if="pageDevice.frApp && pageDevice.frApp.length != 0 && isLoginUserPageItemWritable">
          <div class="gridColumnTitle pt-2" style="line-height: 180%;">
            <b-button size="sm" variant="light" class="p-0 m-0 border-0" style="background-color: #e9ecef;"
              v-b-tooltip.focus title="친구로 지정된 사용자는 공개 여부가 공개안함이더라도 기기의 데이터를 읽을 수 있습니다.">친구 목록</b-button>
          </div>
          <div class="gridColumnBody">
            <ul class="m-0 ml-3 p-0">
              <li v-for="friend in pageDevice.frApp" :key="friend">
                <router-link v-if="pageDevice.frAppCache[friend]" :to="{ name: 'tinkUser', params: { uid: friend } }"
                  custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{ (pageDevice.frAppCache[friend].displayName)? pageDevice.frAppCache[friend].displayName : friend
                    }}
                  </span>
                </router-link>
                <router-link v-else :to="{ name: 'tinkUser', params: { uid: friend } }" custom v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{ friend }}
                  </span>
                </router-link>
                <a v-if="pageDevice.frAppCache[friend]&&pageDevice.frAppCache[friend].email"
                  :href="`mailto:${pageDevice.frAppCache[friend].email}`">({{ pageDevice.frAppCache[friend].email
                  }})</a>
                <b-button size="sm"
                  :class="(!isLoginUserPageItemWritable || pageDevice.inherit)? 'd-none pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot7 ml-dot1 mr-3':'pl-1 pr-1 pt-dot1 pb-dot1 fontSizeDot7 ml-dot1 mr-3'"
                  @click="deleteFriend(friend)">X</b-button>
              </li>
            </ul>
          </div>
        </div>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable && !pageDevice.inherit">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="" style="margin-bottom : 0rem">친구 추가</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop v-model="newFriend" id="newFriend"
            pattern="^([^\s@]+@[^\s@]+\.[^\s@]{2,})|([a-zA-Z0-9]{28})$" trim minlength="4" maxlength="64"
            v-b-tooltip.focus title="친구로 추가할 사용자의 전자우편 주소나 ID를 입력하세요. ID는 영문, 숫자로 28 글자로 되어 있습니다."
            v-on:keyup="enterKeyChecker" data-nextfocus="newFriendAdd" />
          <b-button variant="primary" id="newFriendAdd" class="pl-3 pr-3" @click="addFriend" slot="append"
            :disabled="submitDisabled">
            추가
          </b-button>
        </b-input-group>

        <h4 class="border-bottom mt-3 pt-1 pb-1" v-if="isLoginUserPageItemWritable">
          업로드 전달
        </h4>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="devieRelayTo" style="margin-bottom : 0rem">대상</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.relayTo" id="deviceRelayTo"
            :disabled="!isLoginUserPageItemWritable || pageDevice.relayTo == 'elice'" v-b-tooltip.focus
            title="기기가 업로드한 데이터를 다른 서버로 전달합니다.">
            <option value="none" selected>없음</option>
            <option value="elice" disabled>엘리스</option>
            <option value="custom">직접 지정</option>
          </b-form-select>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable && pageDevice.relayTo == 'custom'">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="deviceRelayToMethod" style="margin-bottom : 0rem">방법</label>
          </b-input-group-text>
          <b-form-select v-model="pageDevice.relayToMethod" id="deviceRelayToMethod"
            :disabled="!isLoginUserPageItemWritable || pageDevice.relayTo == 'elice'" v-b-tooltip.focus
            title="아래 전달 주소에 '?device=[기기 ID]&sensor=[센서 이름]'와 같은 형식으로 기기 ID와 센서 이름이 전달됩니다. csv는 시간,값1,...,값N 형식으로, json(array of array)은 [[시간, 값1, 값2, 값N] ,...,[시간, 값1, 값2, 값N]]과 같이 배열을 항목으로 하는 배열로, json(array of object)는 [{t: {_seconds: 초, _nanosecodns: 0}, v: [값1, 값2, ..., 값N]}, ..., {t: {_seconds: 초, _nanosecodns: 0}, v: [값1, 값2, ..., 값N]}]과 같이 개체를 항목으로 하는 배열로 전달합니다. 기본값은 json(array of object)입니다.">
            <option value="json">post method, request body=json(array of object)</option>
            <option value="aoa">post method, request body=json(array of array)</option>
            <option value="csv">post method, request body=csv</option>
          </b-form-select>
        </b-input-group>

        <b-input-group size="sm" class="mt-1" v-if="isLoginUserPageItemWritable && pageDevice.relayTo == 'custom'">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="relayToCustomURL" style="margin-bottom : 0rem">전달 주소</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop v-model="pageDevice.relayToCustomURL" id="relayToCustomURL" trim
            minlength="4" maxlength="256" v-b-tooltip.focus title="전달할 주소에서 앞 부분을 적어주세요." />
        </b-input-group>

        <div class="mt-1 gothic gridColumn" v-if="isLoginUserPageItemWritable && pageDevice.relayTo == 'custom'">
          <div class="gridColumnTitle pt-2">전달 테스트</div>
          <div class="gridColumnBody">
            <ul class="m-0 ml-3 p-0">
              <li v-for="(item) in pageDevice.sensors" :key="item.id" class="mb-1">
                <span>
                  {{ item.name }}
                </span>
                <b-button size="sm" type="button" variant="primary" class="mr-1 pt-dot1 pb-dot1 fontSizeDot8"
                  @click="testRelayTo(item.name, $event)"
                  v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable">
                  데이터 전달 테스트
                </b-button>
              </li>
              <li v-if="pageDeviceSensorsLength == 0">
                없음
              </li>
            </ul>
          </div>
        </div>

        <b-input-group size="sm" class="mt-2"
          v-if="isLoginUserPageItemWritable && pageDevice.relayTo == 'custom' && relayToTestURL != ''">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label for="relayToTestURL" class="mb-0">테스트 주소</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop readonly id="relayToTestURL" v-model="this.relayToTestURL" />
        </b-input-group>

        <b-input-group size="sm" class="mt-2"
          v-if="isLoginUserPageItemWritable && pageDevice.relayTo == 'custom' && relayToTestBody != ''">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="relayToTestBody">테스트 본문</label>
          </b-input-group-text>
          <b-form-textarea v-touch:swipe.stop rows="3" max-rows="8" id="relayToTestBody" v-model="this.relayToTestBody"
            v-b-tooltip.focus readonly style="overflow-y: hidden" trim required></b-form-textarea>
        </b-input-group>

        <b-input-group size="sm" class="mt-2"
          v-if="isLoginUserPageItemWritable && pageDevice.relayTo == 'custom' && relayToTestBody != ''">
          <b-input-group-text slot="prepend" class="leftCellTitle">
            <label class="mb-0" for="relayToTestResult">테스트 결과</label>
          </b-input-group-text>
          <b-form-textarea v-touch:swipe.stop rows="3" max-rows="8" id="relayToTestResult"
            v-model="this.relayToTestResult" v-b-tooltip.focus readonly style="overflow-y: hidden" trim
            required></b-form-textarea>
        </b-input-group>

        <div class="mt-3 text-left"
          v-if="isLoginUserPageItemWritable || ((typeof(pageDevice.oAdmin) != 'undefined' && pageDevice.oAdmin == loginUser.id)||isLoginUserAdmin)">

          <b-button variant="outline-dark" v-b-modal.deleteDeviceFloat size="sm"
            v-if="isLoginUserPageItemWritable && !pageDevice.disabled" :disabled="submitDisabled">
            <b-spinner small type="grow" class="mr-1" v-if="showDeleteSpinner"></b-spinner>
            기기 삭제하기
          </b-button>
          <b-button variant="outline-dark" class="ml-1" v-b-modal.takeDeviceFloat size="sm"
            v-if="(!pageDevice.disabled && ((typeof(pageDevice.oAdmin) != 'undefined' && pageDevice.oAdmin == loginUser.id) || isLoginUserAdmin)) && (pageDevice.owner != loginUser.id)"
            :disabled="submitDisabled">
            기기 소유권 가져오기
          </b-button>

          <b-button size="sm" v-if="isLoginUserPageItemWritable && !pageDevice.disabled" @click="updateDeviceInfo"
            variant="danger" id="updateDeviceInfo"
            :disabled="!this.pageBinded || this.pageDevice.disabled || submitDisabled" class="float-right">
            <b-spinner small type="grow" class="mr-1" v-if="showUpdateSpinner"></b-spinner>기본설정 저장하기
          </b-button>

        </div>
      </b-form>
    </div>

    <b-modal v-touch:swipe.stop size="lg" id="takeDeviceFloat" tabindex="-1" title="기기 소유권 가져오기" static
      @show="modalShowFocus" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light"
      footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3"
      content-class="border-0" button-size="sm">

      <div class="gothic fontSizeDot9" style="line-height: 170%;">
        <p>
          당신은 이 기기의 시리얼 번호 기본 관리자입니다. 이 기기 등록시에 사용한 시리얼 번호와 인증코드를 알고 있으면 기기의 소유권을 가져올 수 있습니다. 기기 소유권 가져오기를 실행한 후에는 취소할 수
          없습니다. <b>인증코드는 기기의 접속 코드와 다른 코드이며, 팅커블 IoT 키트 바닥에 시리얼 번호와 함께 적혀있습니다.</b>
        </p>
        <p>
          기기 소유권을 가져올 때 현재 기기 소유자를 기기 관리자로 지정하므로, 현재 기기의 소유자도 이 기기에 대한 쓰기 권한을 계속 가집니다. 현재 기기 소유자의 쓰기 권한을 없애려면 기기 소유권을
          가져온 다음에 기기 기본설정 페이지에서 현재 기기의 소유자를 관리자에서 삭제하시기 바랍니다.
        </p>
      </div>
      <b-form @submit.stop.prevent class="was-validated">
        <b-input-group size="sm" class="mb-1">
          <b-input-group-text slot="prepend" style="width: 8rem;">
            <label for="" style="margin-bottom : 0rem">시리얼 번호</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop id="takeDeviceSerialNumber" placement="bottom"
            v-model="takeDeviceSerialNumber" class="gothic" style="letter-spacing: 2px; color: red; font-weight: bold;"
            v-b-tooltip.focus title="기기의 시리얼번호는 영문대소문자로 되어있습니다. AAAA-AAAA-AAAA-AAAA와 같은 형식입니다. 대소문자는 구별합니다."
            v-on:keyup="this.enterKeyChecker" data-nextfocus="takeDeviceAuthCode"
            pattern="^[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}-[A-Za-z]{4}$" minlength="19" maxlength="19" required trim />
        </b-input-group>
        <b-input-group size="sm" class="mb-2">
          <b-input-group-text slot="prepend" style="width: 8rem;">
            <label for="" style="margin-bottom : 0rem">인증 코드</label>
          </b-input-group-text>
          <b-form-input v-touch:swipe.stop id="takeDeviceAuthCode" placement="bottom" v-model="takeDeviceAuthCode"
            class="gothic" style="letter-spacing: 2px; color: red; font-weight: bold;" v-on:keyup="this.enterKeyChecker"
            data-nextfocus="takeDeviceButton" minlength="19" maxlength="19" required trim v-b-tooltip.focus
            title="기기의 인증 코드입니다.숫자로 되어있습니다. 9999-9999-9999-9999와 같은 형식입니다." pattern="^\d{4}-\d{4}-\d{4}-\d{4}$" />

        </b-input-group>
      </b-form>

      <template slot="modal-footer">
        <b-button id="takeDeviceButton" variant="secondary" size="sm" @click="takeDevice" class="mr-2"
          :disabled="submitDisabled">
          기기 소유권 가져오기 실행
        </b-button>
        <b-button variant="danger" size="sm" @click="closeTakeDeviceModal" :disabled="submitDisabled"
          style="width: 6rem">
          닫기
        </b-button>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop size="lg" id="deleteDeviceFloat" tabindex="-1" title="기기 삭제하기" static
      @show="modalShowFocus" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light"
      footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3"
      content-class="border-0" button-size="sm">

      <div v-if="countAttributes(pageDevice.sensors) != 0">
        <p class="fontSizeDot9" style="line-height: 170%;">
          데이터를 삭제하고, 센서를 삭제한 후에 기기를 삭제할 수 있습니다. 데이터는 삭제한 다음에는 복구할 수 없습니다. 데이터가 아주 많은 경우에 데이터 삭제하기를 여러 번 해야할 수도 있습니다.
        </p>
        <ul class="m-0 ml-2 p-0">
          <li v-for="(item) in pageDevice.sensors" :key="item.id" class="m-3 menuRow"
            style="grid-template-columns: auto auto;">

            <div style="grid-area: left;">
              {{item.title}} ({{item.name}})
              <span v-if="(item.lastBook*1000 + item.lastIndex + 1) != 0">:
                <br class="displayBlockMin589" />
                데이터
                <router-link :to="{ name: 'tinkSensor', params: { sid: item.id, mode: 'download'} }" custom
                  v-slot="{ navigate }">
                  <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
                    {{(item.lastBook*1000 + item.lastIndex + 1).toLocaleString("ko-KR")}}
                  </span>
                </router-link> 줄
              </span>
            </div>

            <div style="grid-area: right; text-align: right;">

              <b-button type="button" variant="primary" size="sm" class="fontSizeDot8 pl-1 pr-1 pt-dot2 pb-dot2 mr-1"
                :disabled="doingBackup"
                v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable && (item.lastBook != 0 || item.lastIndex != -1) && typeof(backupUri[item.name]) != 'undefined' && backupUri[item.name] != null"
                :href="backupUri[item.name]" :download="`${item.name}_backup.csv`">
                백업파일 다운로드
              </b-button>

              <b-button variant="primary" size="sm" :disabled="doingBackup" @click="backupSensorData(item.name, $event)"
                class="fontSizeDot8 pl-1 pr-1 pt-dot2 pb-dot2 mr-1"
                v-if="pageBinded && !pageDevice.disabled && isLoginUserPageItemWritable && (item.lastBook != 0 || item.lastIndex != -1) && (typeof(backupUri[item.name]) == 'undefined' || backupUri[item.name] == null)">
                백업파일 만들기
              </b-button>

              <b-button v-if="item.lastBook != 0 || item.lastIndex != -1" variant="danger" size="sm"
                :disabled="doingBackup" @click="deleteSensorData(item.name, $event)"
                class="fontSizeDot8 pl-1 pr-1 pt-dot2 pb-dot2">
                데이터 삭제
              </b-button>

              <b-button v-else variant="secondary" size="sm" :disabled="doingBackup"
                @click="deleteSensor(item.name, $event)" class="fontSizeDot8 pl-1 pr-1 pt-dot2 pb-dot2">
                센서 삭제
              </b-button>
            </div>
          </li>
        </ul>


      </div>

      <div v-else>
        <p>
          기기를 삭제한 후에는 복구할 수 없습니다.
          기기를 삭제한 후에는 시리얼 번호와 인증코드를 재사용하여 새로운 기기를 등록할 수 있습니다.
        </p>

        <p>
          아래 입력칸에 이 기기의 이름인 <b><big class="gothic"
              style="letter-spacing: 2px; color: red;">{{this.pageDevice.name}}</big></b>을
          입력해주세요. 대소문자를 구별하며, 공백도 정확하게 입력해야합니다.
        </p>

        <b-form @submit.stop.prevent class="was-validated">
          <b-input-group>
            <b-input-group-text slot="prepend">
              <label for="" style="margin-bottom : 0rem">삭제할 기기의 이름</label>
            </b-input-group-text>
            <b-form-input v-touch:swipe.stop id="deleteDeviceConfirmInput" title="" trim
              v-model="deleteDeviceConfirmName" @keydown="disableCtrlV" @contextmenu="disableContextMenu" class="gothic"
              style="letter-spacing: 2px; color: red; font-weight: bold;"
              :pattern="'^' + this.pageDevice.name.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') + '$'" />
          </b-input-group>
        </b-form>

      </div>

      <template slot="modal-footer" v-if="countAttributes(pageDevice.sensors) == 0">
        <b-button variant="outline-secondary" size="sm" @click="deleteDevice"
          :disabled="pageDevice.name != deleteDeviceConfirmName || pageDevice.disabled || submitDisabled">
          <b-spinner small type="grow" class="mr-1" v-if="showDeleteSpinner"></b-spinner>
          기기 삭제하기
        </b-button>
        <b-button variant="primary" size="sm" @click="closeDeleteDeviceModal" :disabled="submitDisabled">
          닫기
        </b-button>
      </template>
      <template slot="modal-footer" v-else>
        <b-button variant="primary" size="sm" @click="closeDeleteDeviceModal" :disabled="submitDisabled">
          닫기
        </b-button>
      </template>

    </b-modal>

    <b-toast id="backupSensorDataToast" class="b-toaster" title="센서 데이터 백업하는 중..." variant="primary" no-auto-hide>
      <p>
        <b-spinner small type="grow" variant="danger" class="mr-1" v-if="doingBackup"></b-spinner>
        <span class="font-weight-bold text-danger">{{ this.backupSensorDataMessage }}</span>
        <b-spinner small type="grow" variant="danger" class="ml-1" v-if="doingBackup"></b-spinner>
      </p>
    </b-toast>

  </div>

</template>
<script>
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"
// import { gmapApi } from "vue2-google-maps";
import { gmapApi } from "gmap-vue";

import uiUtil from "@/mixins/util.js"
import mapUtil from "@/mixins/mapUtil.js"
import user from "@/mixins/user.js"
import functions from "@/mixins/functions.js"

import deviceTabs from "@/components/device/deviceTabs.vue"


export default {
  name: "deviceIntro",
  mixins: [uiUtil, mapUtil, user, functions],
  props: {
    pageUser: Object,
    pageDevice: Object,
    pageBinded: Boolean,
  },
  components: {
    deviceTabs,
  },
  data: function() {
    return {
      backupUri: {},
      doingBackup: false,
      backupSensorDataMessage: "",
      submitDisabled: false,
      showUpdateSpinner: false,
      showDeleteSpinner: false,
      gmapInited: false,
      centerPosition: { "lat": 37.545576, "lng": 126.959690 },
      gmapPopup: null,
      gmapPlaceSearch: "",
      oldInherit: null,
      oldOpen: null,
      oldAdmin: null,
      oldFrApp: null,
      lastPlace: null,
      deleteDeviceConfirmName: "",
      showLocationInfoPhotos : false,
      newAdminIdOrEmail: "",
      newFriend: "",
      adminEditing: false,
      takeDeviceSerialNumber: "",
      takeDeviceAuthCode: "",
      relayToTestURL: "",
      relayToTestBody: "",
      relayToTestResult: ""
    }
  },
  mounted: function() {

    if(typeof(this.pageDevice.macAddress) == "undefined") {
      this.pageDevice.macAddress = ""
    }

    if(typeof(this.pageDevice.admin) == "undefined") {
      this.pageDevice.admin = ""
    }
    else {
      this.oldAdmin = this.pageDevice.admin;
    }

    if(typeof(this.pageDevice.open) == "undefined") {
      this.pageDevice.open = true;
    }
    else {
      this.oldOpen = this.pageDevice.open;
    }

    if(typeof(this.pageDevice.inherit) == "undefined") {
      this.pageDevice.inherit = true;
    }
    else {
      this.oldInherit = this.pageDevice.inherit;
    }

    if(typeof(this.pageDevice.frApp) == "undefined") {
      this.pageDevice.frApp = [];
    }
    else {
      this.oldFrApp = this.pageDevice.frApp.concat([]);
    }

    if(typeof(this.pageDevice.useMacAddress) == "undefined") {
      this.makeToast("warning", "기기 설정 업데이트 필요", "기기 설정이 오래되었습니다. MAC 주소, Mac 주소 사용, 센서 목록 응답 설정을 살펴보시고 기기 정보를 저장해주세요.", {
        "autoHideDelay": 3000,
        "body-class": "fontSizeDot8",
        "header-class": "fontSizeDot8",
      })
      this.pageDevice.useMacAddress = false
    }
    if(typeof(this.pageDevice.useSensorsResponse) == "undefined") {
      this.pageDevice.useSensorsResponse = false
    }

    if(typeof(this.pageDevice.locationZoom) == "undefined") {
      this.pageDevice.locationZoom = 13
    }
    if(this.pageDevice.location == null) {
      this.pageDevice.locationZoom = 8
    }
    if(typeof(this.pageDevice.locationPopupFontSize) == "undefined") {
      this.pageDevice.locationPopupFontSize = 14
    }
    if(typeof(this.pageDevice.locationInfo) == "undefined") {
      this.pageDevice.locationInfo = null
    }

    if (typeof (this.pageDevice.relayTo) == "undefined") {
      this.pageDevice.relayTo = "none"
    }

    if (typeof (this.pageDevice.relayToCustomURL) == "undefined") {
      this.pageDevice.relayToCustomURL = ""
    }

    if (typeof (this.pageDevice.relayToMethod) == "undefined") {
      this.pageDevice.relayToMethod = "aoa"
    }

    if(this.pageDevice.location != null) {
      this.centerPosition = {
        lat: this.pageDevice.location.latitude,
        lng: this.pageDevice.location.longitude,
      }
    }
  },
  methods: {

    doNothing: function() {
    },

    backupSensorData: function(sensor, evt) {
      if(typeof(evt) != "undefined") {
        evt.stopPropagation();
      }

      let items = [];
      let successCount = 0;
      let bookList = {};
      let totalRow = (this.pageDevice.sensors[sensor].lastBook*1000) + this.pageDevice.sensors[sensor].lastIndex + 1;

      this.$bvToast.show("backupSensorDataToast");
      this.doingBackup = true;
      this.backupSensorDataMessage = (totalRow>10000)?"서버에서 데이터를 가져오는 중입니다. 데이터가 많아 시간이 오래 걸립니다.":"서버에서 데이터를 가져오는 중입니다.";

      for(let bookIndex in this.pageDevice.sensors[sensor].bookInfo) {
        db.collection("sensors").doc(this.pageDevice.sensors[sensor].id).collection("history").doc(bookIndex+ "")
        .get()
        .then(book => {
          if(book.exists) {

            bookList[book.id] = book.data();

            if(successCount++ == this.pageDevice.sensors[sensor].lastBook) {

              this.backupSensorDataMessage = (totalRow>10000)?"데이터를 모두 가져왔습니다. 파일을 만듭니다. 데이터가 많아 시간이 오래 걸립니다.":"데이터를 모두 가져왔습니다. 파일을 만듭니다.";

              for(let i=0;i<=this.pageDevice.sensors[sensor].lastBook;i++) {
                let endId = (i == this.pageDevice.sensors[sensor].lastBook)? this.pageDevice.sensors[sensor].lastIndex: 999;
                for(let j=0;j<=endId;j++) {
                  items.push([bookList[i + ""][j+""].t.seconds, ...bookList[i + ""][j+""  ].v].join(","));
                }
              }

              let blob = new Blob([items.join("\n")], {
                type: "text/plain;charset=utf-8"
              });

              if(typeof(this.backupUri[sensor]) != "undefined" && this.backupUri[sensor] != null) {
                URL.revokeObjectURL(this.backupUri[sensor]);
                this.$set(this.backupUri, sensor, null);
              }
              this.$set(this.backupUri, sensor, URL.createObjectURL(blob));

              this.doingBackup = false;
              this.backupSensorDataMessage = "다운로드할 준비가 끝났습니다. 백업파일을 다운로드 하세요.";

              window.setTimeout(()=> {
                this.$bvToast.hide("backupSensorDataToast");
              }, 5000);

            }
          }
          else {
            if(bookIndex == 0) {
              this.makeToast("danger", "백업 실패", "데이터가 없습니다.");
            }
            else {
              this.makeToast("danger", "백업 실패", bookIndex + "번 묶음 데이터가 없습니다.");
            }
          }
        })
        .catch(error => {
          this.makeToast("danger", "백업실패", "데이터 조회 중 에러가 발생했습니다. 에러 내용: " + error);
        })
      }
    },

    addFriend: function() {

      if(!window.document.getElementById('newFriend').checkValidity()) {
        window.document.getElementById('newFriend').reportValidity();
        window.document.getElementById('newFriend').focus();
        return;
      }

      if(this.newFriend == this.pageUser.id || this.newFriend == this.pageUser.email) {
        this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("tHeader.canNotAddMySelf"));
        window.document.getElementById('newFriend').select();
        window.document.getElementById('newFriend').focus();
        return;
      }

      if(this.newFriend.indexOf("@") == -1) {
        if(this.pageDevice.frApp.some(item => { item == this.newFriend })) {
          this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("alreadyAddedAsFriend"));
          window.document.getElementById('newFriend').select();
          window.document.getElementById('newFriend').focus();
          return;
        }
      }
      this.submitDisabled = true;
      this.getWithAuth(this.functionsServer + "/app/isExistUid?uid=" + this.newFriend)
      .then(result=> {
        if(result.status != 200) {
          this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.serverError", {
            status: result.status,
            statusText: result.statusText
          }));
        }
        else {
          if(result.data.success) {
            if(typeof(result.data.uid) != "undefined") {

              if(this.pageDevice.frApp.some(item=>(item==result.data.uid))) {
                this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("alreadyAddedAsFriend"));
                window.document.getElementById('newFriend').select();
                window.document.getElementById('newFriend').focus();
              }
              else {
                this.pageDevice.frApp.push(result.data.uid);
                let toAdd = {
                  displayName: result.data.displayName
                }
                if(result.data.email) toAdd.email = result.data.email;
                this.$set(this.pageDevice.frAppCache, result.data.uid, toAdd);
                this.newFriend = "";
                window.document.getElementById('newFriend').focus();
                this.makeToast("success", this.$t("common.addFriendSuccess"), this.$t("common.addFriendSuccessbody"));
              }
            }
            else {
              this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.noIdInResponse"));
            }
          }
          else {
            if(result.data.error == 1) {
              this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.errorInServer"));
            }
            else if(result.data.error == 2) {
              this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.noUserWithThatInfo"));
            }
            else if(result.data.error == 3) {
              this.makeToast("danger", this.$t("tHeader.failToAddFriend"), this.$t("common.duplicatedEmailUser"));
            }
          }
        }
        this.submitDisabled = false;
      })
      .catch(error => {
        this.makeToast("danger", this.$t("tHeader.failToAddFriend"), `요청을 보내지 못했습니다. 에러 내용: ${error}`);
        window.setTimeout(()=> {
          this.requestDisabled = false;
        }, 5000);
        this.submitDisabled = false;
      });
    },

    deleteFriend: function(friend) {
      this.pageDevice.frApp = this.pageDevice.frApp.filter(item => {
        if(item == friend) return false;
        else return true;
      })
      if(typeof(this.pageDevice.frAppCache[friend]) != "undefined") {
        delete(this.pageDevice.frAppCache[friend]);
      }
    },
    cancelEditAdmin: function() {
      this.adminEditing = false;
    },
    applyNewAdmin: function() {

      if(this.newAdminIdOrEmail != "" && !window.document.getElementById('newAdminIdOrEmail').checkValidity()) {
        window.document.getElementById('newAdminIdOrEmail').reportValidity();
        window.document.getElementById('newAdminIdOrEmail').focus();
        return;
      }

      if(this.newAdminIdOrEmail == "") {
        this.adminEditing = false;
        this.pageDevice.admin = "";
      }
      else {
        if(this.newAdminIdOrEmail == this.pageUser.id || this.newAdminIdOrEmail == this.pageUser.email) {
          this.makeToast("danger", "ID 또는 전자우편 조회 실패", "기기 소유자를 관리자로 지정할 수 없습니다.");
          window.document.getElementById('newAdminIdOrEmail').select();
          window.document.getElementById('newAdminIdOrEmail').focus();
          return;
        }


        this.submitDisabled = true;
        this.getWithAuth(this.functionsServer + "/app/isExistUid?uid=" + this.newAdminIdOrEmail)
        .then(result=> {
          if(result.status != 200) {
            this.makeToast("danger", "ID 조회 실패", `서버에 확인하는 중에 에러가 발생했습니다. 상태 코드: ${result.status}, 상태 메시지: ${result.statusText}`);
          }
          else {
            if(result.data.success) {
              if(typeof(result.data.uid) != "undefined") {
                this.makeToast("success", "관리자 ID로 적용 성공", `${this.newAdminIdOrEmail}의 ID인 ${result.data.uid}를 관리자 ID로 지정했습니다.`);
                this.pageDevice.admin = result.data.uid;
                this.adminEditing = false;
              }
              else {
                this.makeToast("danger", "ID 조회 실패", this.$t("common.noIdInResponse"));
              }
            }
            else {
              if(result.data.error == 1) {
                this.makeToast("danger", "ID 조회 실패", this.$t("common.errorInServer"));
              }
              else if(result.data.error == 2) {
                this.makeToast("danger", "ID 조회 실패", this.$t("common.noUserWithThatInfo"));
              }
              else if(result.data.error == 3) {
                this.makeToast("danger", "ID 조회 실패", this.$t("common.duplicatedEmailUser"));
              }
            }
          }
          this.submitDisabled = false;
        })
        .catch(error => {
          this.makeToast("danger", "ID 조회 실패", `요청을 보내지 못했습니다. 에러 내용: ${error}`);
          window.setTimeout(()=> {
            this.requestDisabled = false;
          }, 5000);
          this.submitDisabled = false;
        });
      }
    },
    editAdmin: function() {
      this.adminEditing = true;
      window.setTimeout(()=> {
        window.document.getElementById("newAdminIdOrEmail").focus();
      },100);
    },
    closeTakeDeviceModal: function() {
      this.hideModal('takeDeviceFloat')
    },
    closeDeleteDeviceModal: function() {
      this.hideModal('deleteDeviceFloat')
    },
    openNewGmapWindow: function() {
      if(this.pageDevice.location) {
        window.open("https://maps.google.com/?q=" + this.pageDevice.location.latitude + "," + this.pageDevice.location.longitude)
      }
    },
    checkGmapLoaded: function() {
      if(this.$refs.gmap && this.$refs.gmap.$mapPromise) {
        this.$refs.gmap.$mapPromise.then((map) => {
          let gmapPopupClass = this.createPopupClass()
          // eslint-disable-next-line
          this.gmapPopup = new gmapPopupClass(new google.maps.LatLng(this.centerPosition.lat, this.centerPosition.lng), "gmapPopup")
          this.gmapPopup.setMap(map)

          window.document.getElementById('gmapPopup').style.fontSize = this.pageDevice.locationPopupFontSize + "px"

          if(this.pageDevice.location != null) {
            this.gmapPopup.element.style.visibility = "visible"
          }
          else {
            this.gmapPopup.element.style.visibility = "hidden"
          }

          window.setTimeout(() => {
            // eslint-disable-next-line
            this.$refs.gmap.$mapObject.controls[google.maps.ControlPosition.RIGHT_TOP].push(window.document.getElementById("gmapTextSize"))
            // eslint-disable-next-line
            window.document.getElementById("gmapTextSize").style.visibiliy = "visible"
            if(this.isLoginUserPageItemWritable) {
              // eslint-disable-next-line
              this.$refs.gmap.$mapObject.controls[google.maps.ControlPosition.TOP_LEFT].push(window.document.getElementById("gmapAutoComplete"))
              window.document.getElementById("gmapAutoComplete").style.visibility = "visible"
            }
            else {
              if(window.document.getElementById("gmapAutoComplete")) {
                window.document.getElementById("gmapAutoComplete").style.visibility = "hidden"
              }
            }
          }, 1000)
        }).catch((error) => {
          this.$log.error(error)
        })
      }
      else {
        window.setTimeout(() => {
          this.checkGmapLoaded()
        }, 100)
      }
    },
    initGmap: function() {
      if(!this.gmapInited) {
        this.gmapInited = true
        this.checkGmapLoaded()
      }
    },
    applyDevicePhotoURL: function(evt) {
      this.pageDevice.photoURL = evt.srcElement.dataset.photourl
    },
    deleteLocation: function() {
      if(this.isLoginUserPageItemWritable) {
        this.pageDevice.location = null
        this.pageDevice.locationInfo = null
        this.pageDevice.locationZoom = null
        this.pageDevice.locationPopupFontSize = null
        if(this.gmapInited) {
          this.gmapPopup.element.style.visibility = "hidden"
        }
      }
    },
    // https://script.google.com/macros/s/AKfycbxJyFPW9QBaf8JF478V1U9CU-vfHRaZNW-KGUUj8hoWEAkqv92Jxm1oGnLnK3t3gNpt/exec
    // https://script.google.com/macros/s/AKfycbxJyFPW9QBaf8JF478V1U9CU-vfHRaZNW-KGUUj8hoWEAkqv92Jxm1oGnLnK3t3gNpt/exec?device=cFCEyWlfzzhjD38isFgp&sensor=bme280
    // https://script.google.com/macros/s/AKfycbwLCLVwOTFzbuBnY0EUnTDKFq3zhX_qpzVegeNR15zWXgxIKlXoIsVroN8pSlJK9_DF/exec?device=cFCEyWlfzzhjD38isFgp&sensor=bme280
    // https://script.google.com/macros/s/AKfycbwLCLVwOTFzbuBnY0EUnTDKFq3zhX_qpzVegeNR15zWXgxIKlXoIsVroN8pSlJK9_DF/exec
    // https://script.google.com/macros/s/AKfycbybj21MEy8B-iDIcmJwNE3-7QbMqO8aGx60Z63i4-ZVTfD5a9FR4K1s_4x-AhHx6NkF/exec?device=cFCEyWlfzzhjD38isFgp&sensor=bme280

    testRelayTo: async function(sensor, evt) {
      if (typeof (evt) != "undefined")
      {
        evt.stopPropagation();
      }
      let repeat = this.makeRandomInt(1, 10)
      repeat = 2
      let seedDate = parseInt(Date.now() / 1000);
      
      if(this.pageDevice.relayToMethod == "json")
      {
        let testData = new Array();
        for (let j = 0; j < repeat; j++)
        {

          let testDataItem = new Object();
          testDataItem.t = { 
            "_seconds" : seedDate - repeat + j,
            "_nanoseconds": 0
          };
          testDataItem.v = new Array();
          this.pageDevice.sensors[sensor].values.filter(value => {
            return ((value.hold) ? false : true);
          }).forEach((value, index) => {
            testDataItem.v.push(this.makeRandomValue(value.type, value.min, value.max))
          });
          testData.push(testDataItem);
        }
        this.relayToTestBody = JSON.stringify(testData);
      }
      else if(this.pageDevice.relayToMethod == "aoa")
      {
        let testData = new Array();
        for (let j = 0; j < repeat; j++)
        {

          let testDataItem = new Array();
          testDataItem.push(seedDate - repeat + j);
          this.pageDevice.sensors[sensor].values.filter(value => {
            return ((value.hold) ? false : true);
          }).forEach((value, index) => {
            testDataItem.push(this.makeRandomValue(value.type, value.min, value.max))
          });
          testData.push(testDataItem);
        }
        this.relayToTestBody = JSON.stringify(testData);
      }
      else if(this.pageDevice.relayToMethod == "csv")
      {
        let testData = "";
        for (let j = 0; j < repeat; j++)
        {

          testData += seedDate - repeat + j;
          this.pageDevice.sensors[sensor].values.filter(value => {
            return ((value.hold) ? false : true);
          }).forEach((value, index) => {
            testData += "," + this.makeRandomValue(value.type, value.min, value.max)
          });
          testData += "\n"; 
        }
        if(testData.length != 0)
        {
          testData = testData.substring(0, testData.length-1);
        }
        this.relayToTestBody = testData;
      }

      this.relayToTestResult = "";
      let testURL = this.pageDevice.relayToCustomURL + "?device=" + this.pageDevice.id + "&sensor=" + sensor;
      this.relayToTestURL = testURL;

      try
      {
        const response = await this.post(testURL, this.relayToTestBody, {
          "headers": { 
            "Content-Type": "text/plain"
          },
          json: false
        });
        this.makeToast("success", "전달 성공", "전달에 성공했습니다.", {
            "autoHideDelay": 3000
          });
        this.relayToTestResult = "success!!! status: " + response.status + ", data: " + response.data;
      }
      catch (error)
      {
        this.makeToast("danger", "전달 실패", "에러가 발생했습니다. " + error, {
            "autoHideDelay": 3000
          })
        this.relayToTestResult = "error!!! " + error;
      }
    },
    clickPopup: function(evt) {
      this.$log.debug(evt);
      if(this.isLoginUserPageItemWritable) {
        this.pageDevice.location = new firebase.firestore.GeoPoint(evt.latLng.lat(), evt.latLng.lng());
        this.gmapPopup.position = evt.latLng;
        this.gmapPopup.element.style.visibility = "visible";
        this.gmapPopup.draw();
        if(this.lastPlace) {

          this.$log.debug(this.lastPlace);
          let _distance = this.computeDistanceBetween(this.geopointToGmapLatLng(this.gmapPopup.position),this.geopointToGmapLatLng(this.lastPlace.geometry.location));

          this.$log.debug(this.lastPlace.geometry.viewport);

          let _viewPortDistance = this.computeDistanceBetween(this.geopointToGmapLatLng(this.viewPortTopLeft(this.lastPlace.geometry.viewport)),this.geopointToGmapLatLng(this.viewPortBottomRight(this.lastPlace.geometry.viewport)));

          let _isInside = this.geopointIsInsideViewPort(this.gmapPopup.position, this.lastPlace.geometry.viewport);

          if(_isInside && _distance < 100 && _viewPortDistance < 10000) {

            let _todo = ["formatted_address", "international_phone_number", "name", "place_id", "website", "photos"];

            this.pageDevice.locationInfo = {};

            _todo.forEach((item) => {
              if(typeof(this.lastPlace[item]) != "undefined") {
                  this.pageDevice.locationInfo[item] = this.lastPlace[item];
              }
            })

            if(typeof(this.lastPlace.photos) != "undefined") {
              this.showLocationInfoPhotos = false;
              this.pageDevice.locationInfo.photos = {};
              this.lastPlace.photos.forEach((item,index, array) => {
                this.$http.get(this.functionsServer + "/app/getImageUrl?url=" + encodeURIComponent(item.getUrl({maxWidth: 600, maxHeight: 400})), {
                  headers: {'Access-Control-Allow-Origin': '*'},
                  crossdomain: true
                })
                .then(result => {
                  if(result.data.success) {
                    if(index == (array.length-1)) {
                      this.showLocationInfoPhotos = true;
                    }
                    this.pageDevice.locationInfo.photos[result.data.location] = true;
                  }
                })
                .catch(error => {
                  this.$log.debug(error);
                })
              })
            }

            if(typeof(this.lastPlace.geometry) != "undefined") {
              this.pageDevice.locationInfo.geometry = {}
              if(typeof(this.lastPlace.geometry.location) != "undefined") {
                this.pageDevice.locationInfo.geometry.location = {
                  "lat": this.lastPlace.geometry.location.lat(),
                  "lng": this.lastPlace.geometry.location.lng(),
                }
              }

              if(typeof(this.lastPlace.geometry.viewport) != "undefined") {

                // (vp.Ya.j, vp.Sa.i) ........... (vp.Ya.j, vp.Sa.j)
                // (vp.Ua.i, vp.La.g)
                //                                (vp.Ua.g, vp.La.i)
                // (vp.Ya.i, vp.Sa.i) ........... (vp.Ya.i, vp.Sa.j)

                this.pageDevice.locationInfo.geometry.viewport = [
                  {
                    //"lat": this.lastPlace.geometry.viewport.Ya.j,
                    //"lng": this.lastPlace.geometry.viewport.Sa.i,
                    "lat": this.lastPlace.geometry.viewport.Ua.i,
                    "lng": this.lastPlace.geometry.viewport.La.g,
                  },
                  {
                    //"lat": this.lastPlace.geometry.viewport.Ya.i,
                    //"lng": this.lastPlace.geometry.viewport.Sa.j,
                    "lat": this.lastPlace.geometry.viewport.Ua.g,
                    "lng": this.lastPlace.geometry.viewport.La.i,
                  }
                ];
                /*
                this.pageDevice.locationInfo.geometry.viewport = {
                  "Sa": {
                    "j": this.lastPlace.geometry.viewport.Sa.j,
                    "i": this.lastPlace.geometry.viewport.Sa.i,
                  },
                  "Ya": {
                    "j": this.lastPlace.geometry.viewport.Ya.j,
                    "i": this.lastPlace.geometry.viewport.Ya.i,
                  },
                }
                */


              }
            }
          }
        }

      }
    },
    clickMarker: function() {
      // eslint-disable-next-line
      this.$refs.gmap.$mapObject.setCenter(new google.maps.LatLng(this.gmapPopup.position.lat(), this.gmapPopup.position.lng()));
    },
    inputApplyGeopoint: function(evt) {
      this.$log.debug(evt);
      if(this.isLoginUserPageItemWritable) {
        if(evt.srcElement.value == "") {
          this.pageDevice.location = null
          if(this.gmapPopup) {
            this.gmapPopup.element.style.visibility = "hidden"
          }
        }
        else if(evt.srcElement.validity.valid) {
          let _obj = JSON.parse(evt.srcElement.value)
          if(_obj.lat < -90 || _obj.lat > 90) {
            evt.srcElement.value = "실수! lat은 -90이상, 90이하 입니다."
            this.pageDevice.location = null
            this.gmapPopup.element.style.visibility = "hidden"
          }
          else if(_obj.lng < -180 || _obj.lng > 180) {
            evt.srcElement.value = "실수! lng은 -180 이상, 180 이하 입니다."
            this.pageDevice.location = null
            this.gmapPopup.element.style.visibility = "hidden"
          }
          else {
            this.pageDevice.location = new firebase.firestore.GeoPoint(_obj.lat, _obj.lng)
            // eslint-disable-next-line
            this.$refs.gmap.$mapObject.setCenter(new google.maps.LatLng(_obj.lat,_obj.lng))
            this.gmapPopup.element.style.visibility = "visible"
          }
        }
      }
    },
    setPlace: function(place) {
      this.$refs.autocomplete.$el.disabled = "disabled"
      window.setTimeout(() => {
        this.$refs.autocomplete.$el.disabled = ""
      }, 5000);

      if (typeof(place) != "undefined" && place != null) {
        this.lastPlace = place;
        this.pageDevice.locationZoom = 17;
        // eslint-disable-next-line
        this.$refs.gmap.$mapObject.setCenter(new google.maps.LatLng( place.geometry.location.lat(), place.geometry.location.lng()));
        if(typeof(this.lastPlace.photos) != "undefined") {
          window.document.getElementById("photosCollapse").style.display = "block";
        }
        // this.$log.debug(this.lastPlace);
      }
      else {
        this.$log.debug("error in place");
      }
    },
    mapTextSizePlus: function() {
      let fontSize = parseInt(window.getComputedStyle(window.document.getElementById('gmapPopup')).fontSize)
      if(fontSize >= 30) return
      window.document.getElementById('gmapPopup').style.fontSize = ++fontSize + "px"
    },
    mapTextSizeMinus: function() {
      let fontSize = parseInt(window.getComputedStyle(window.document.getElementById('gmapPopup')).fontSize)
      if(fontSize <= 8) return
      window.document.getElementById('gmapPopup').style.fontSize = --fontSize + "px"
    },
    mapTextSize: function() {
      return parseInt(window.getComputedStyle(window.document.getElementById('gmapPopup')).fontSize)
    },

    deleteSensorData: function(sensor, evt) {

      this.$bvModal.msgBoxConfirm("센서의 데이터를 삭제한 후에 취소할 수 없습니다. " + sensor + " 센서의 데이터를 삭제하시겠습니까?", {
        size: "sm",
        buttonSize: "sm",
        okVariant: "secondary",
        okTitle: sensor + " 센서 데이터 삭제",
        cancelTitle: "취소",
        cancelVariant: "danger",
        bodyClass: "gothic",
        footerClass: "p-1 pr-3",
        hideHeaderClose: true,
      })
      .then(confirmed => {
        if(confirmed) {
          let oldActive = this.pageDevice.active;
          let sensorId = this.pageDevice.sensors[sensor].id
          if(oldActive) {
            db.collection("devices").doc(this.pageDevice.id).update({
              active: false
            })
          }

          db.collection("sensors").doc(sensorId).collection("history")
          .get()
          .then(result => {

            let deleted = 0;

            result.docs.forEach(doc => {
                db.collection("sensors").doc(sensorId).collection("history").doc(doc.id).delete()
                .then(() => {
                  deleted++;
                  if(deleted == result.docs.length) {
                    db.collection("sensors").doc(sensorId)
                    .set({
                      bookInfo: {},
                      lastValues: null,
                      lastValuesModified: null,
                      lastBook: 0,
                      lastIndex: -1,
                    },{ merge: true })
                    .then(() => {

                      this.makeToast("info", "데이터 삭제 완료", "센서를 초기화 했습니다.", {
                        "autoHideDelay": 3000
                      });

                      if(oldActive) {
                        db.collection("devices").doc(this.pageDevice.id).update({
                          active: oldActive
                        })
                      }
                    });
                  }
                });
            });
          });
        }
      });
    },

    deleteSensor: function(sensor, evt) {
      evt.stopPropagation();
      if(!this.pageBinded) {
        this.makeToast("danger", "센서 삭제 실패", "실시간이 꺼졌습니다. 센서 삭제는 실시간이 켜진 상태에서만 가능합니다.")
        return;
      }
      if(this.pageDevice.sensors[sensor].lastBook != 0 || this.pageDevice.sensors[sensor].lastIndex != -1) {
        this.makeToast("danger", "센서 삭제 실패", "데이터가 저장된 센서는 삭제할 수 없습니다. 먼저 센서의 데이터를 모두 삭제해주세요.")
        return;
      }

      this.$bvModal.msgBoxConfirm("센서를 삭제한 후에 취소할 수 없습니다. " + sensor + " 센서를 삭제하시겠습니까?", {
        size: "sm",
        buttonSize: "sm",
        okVariant: "secondary",
        okTitle: sensor + " 센서 삭제",
        cancelTitle: "취소",
        cancelVariant: "danger",
        bodyClass: "gothic",
        footerClass: "p-1 pr-3",
        hideHeaderClose: true,
      })
      .then(confirmed => {
        if(confirmed) {
          let sensorId = this.pageDevice.sensors[sensor].id;

          let batch = db.batch();
          batch.update(db.collection('devices').doc(this.pageDevice.id), {
            ["sensors." + sensor]: firebase.firestore.FieldValue.delete()
          });
          batch.delete(db.collection("sensors").doc(sensorId));
          batch.commit()
          .then(() => {
            this.makeToast("success", "센서 삭제 성공", "센서를 삭제했습니다.")
          })
          .catch(error => {
            this.makeToast("danger", "센서 삭제 실패", "센서를 삭제하다가 에러가 났습니다. 에러내용:" + error)
          })
        }
      });

    },

    takeDevice: async function() {

      if(!this.pageBinded) {
        this.makeToast("danger", "기기 소유권 이전 실패", "기기 실시간이 꺼짐 상태에서는 기기 소유권을 가져올 수 없습니다. 상단 제목에서 실시간을 켜주세요.")
        return;
      }

      if(!window.document.getElementById("takeDeviceSerialNumber").checkValidity()) {
        window.document.getElementById("takeDeviceSerialNumber").reportValidity();
        window.document.getElementById("takeDeviceSerialNumber").focus();
        return;
      }
      if(!window.document.getElementById("takeDeviceAuthCode").checkValidity()) {
        window.document.getElementById("takeDeviceAuthCode").reportValidity();
        window.document.getElementById("takeDeviceAuthCode").focus();
        return;
      }

      this.submitDisabled = true;

      let oldActive = this.pageDevice.active;
      if(this.pageDevice.active) {
        await db.collection("devices").doc(this.pageDevice.id).update({
          active: false
        });
      }

      this.postJSONWithAuth(this.functionsServer + "/app/takeDevice", {
        device: this.pageDevice.id,
        deviceName: this.pageDevice.name,
        serial: this.takeDeviceSerialNumber,
        code: this.takeDeviceAuthCode,
        frApp: this.loginUser.frApp,
        frAppCache: this.loginUser.frAppCache,
        open: this.loginUser.open,
        owner: this.pageDevice.owner,
      })
      .then(result=> {
        console.log(result);
        this.submitDisabled = false
        if(result.status != 200) {
          this.makeToast("danger", "기기 소유권 가져오기 실패", "상태코드 " + result.status + ", 상태 메시지 " + result.statusText +"인 에러가 발생해서 기기를 추가하지 못했습니다.", {
            "autoHideDelay": 10000
          })
        }
        else {
          if(result.data.success) {
            this.$parent.$parent.makeToast("success", "기기 소유권 가져오기 성공", "사용자 기기 목록 페이지로 이동합니다.", {
              "autoHideDelay": 10000
            })
            this.$router.push({ name: 'tinkUser', params: { uid: this.loginUser.id, mode: 'list'}, query: { marker: result.data.did} });
          }
          else {
            // 시리얼 번호가 없습니다.
            if(result.data.error == 1) {
              this.makeToast("danger", "기기 소유권 가져오기 실패", "시리얼 번호가 없습니다.", {
                "autoHideDelay": 3000
              })
            }
            // 시리얼 번호, 인증코드, 기기번호, 관리자, 로그인사용자가 일치하지 않습니다.
            else if(result.data.error == 2) {
              this.makeToast("danger", "기기 소유권 가져오기 실패", "시리얼 번호, 인증코드, 기기번호, 관리자, 로그인사용자가 일치하지 않습니다.", {
                "autoHideDelay": 3000
              })
            }
            // 시리얼 번호, 인증코드, 기기번호, 관리자, 로그인사용자가 일치하지 않습니다.
            else if(result.data.error == 2) {
              this.makeToast("danger", "기기 소유권 가져오기 실패", "시리얼 번호, 인증코드, 기기번호, 관리자, 로그인사용자가 일치하지 않습니다.", {
                "autoHideDelay": 3000
              })
            }
            // 업데이트하는 중에 에러가 발생했습니다.
            else {
              this.makeToast("danger", "기기 소유권 가져오기 실패", "업데이트하는 중에 에러가 발생했습니다.", {
                "autoHideDelay": 3000
              })
            }
          }
        }

        if(oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: true
          });
        }

      })
      .catch(error => {
        console.log(error);
        this.submitDisabled = false
        this.makeToast("danger", "기기 소유권 가져오기 실패", "서버로 요청을 보내지 못했습니다. 에러 내용:" + error, {
          "autoHideDelay": 10000
        })

        if(oldActive) {
          db.collection("devices").doc(this.pageDevice.id).update({
            active: true
          });
        }

      })
    },

    deleteDevice: function() {
      if(this.pageDevice.disabled) {
        this.makeToast("danger", "기기 삭제 실패", "정지 중인 기기는 삭제할 수 없습니다.", {
          "autoHideDelay": 3000
        })
        return false
      }

      this.submitDisabled = true
      this.showUpdateSpinner = true

      console.log(this.functionsServer);

      this.postJSONWithAuth(this.functionsServer + "/app/deleteDevice", {
        device: this.pageDevice.id
      })
      .then(result => {
        console.log(result.data);
        this.submitDisabled = false
        this.showUpdateSpinner = false
        if(result.status != 200) {
          this.makeToast("danger", "기기 삭제 실패", "상태코드 " + result.status + ", 상태 메시지 " + result.statusText +"인 에러가 발생해서 기기를 추가하지 못했습니다.", {
            "autoHideDelay": 3000
          })
        }
        else {
          if(result.data.success) {
            this.$parent.$parent.makeToast("success", "기기 삭제 성공", result.data.message + " 사용자 기기 목록 페이지로 이동했습니다.", {
              "autoHideDelay": 3000
            })

            this.$router.push({path: "/u/" + this.loginUser.id })
          }
          else {
            this.makeToast("danger", "기기 삭제 실패", result.data.message, {
              "autoHideDelay": 3000
            })
          }
        }
      })
      .catch(error=> {
        this.submitDisabled = false
        this.showUpdateSpinner = false
        this.makeToast("danger", "기기 삭제 실패.", "서버로 요청을 보내지 못했습니다. 에러 내용: " + error, {
          "autoHideDelay": 3000
        })
      })
    },

    updateDeviceInfo: function() {

      if(this.pageDevice.disabled) {
        this.makeToast("danger", "[" + this.pageDevice.name + "] 기기 정보 수정 실패", "정지 중인 기기는 수정할 수 없습니다.", {
          "autoHideDelay": 3000
        });
        return;
      }

      ["deviceName", "deviceDescription", "devicePhotoURL", "deviceUseSensorsResponse", "deviceUseMacAddress", "deviceActive", "deviceMacAddress", "deviceInherit", "deviceOpen", "deviceLocation", "deviceRelayTo"].forEach(item => {
        if(!window.document.getElementById(item).checkValidity()) {
          window.document.getElementById(item).reportValidity();
          return;
        }
      })

      if(this.gmapInited && this.pageDevice.location != null) {
        this.pageDevice.locationZoom = this.$refs.gmap.$mapObject.getZoom();
        this.pageDevice.locationPopupFontSize = parseInt(window.getComputedStyle(window.document.getElementById('gmapPopup')).fontSize)
        if(this.pageDevice.locationInfo != null) {
          // (vp.Ya.j, vp.Sa.i) ........... (vp.Ya.j, vp.Sa.j)
          // (vp.Ua.i, vp.La.g)
          //                                (vp.Ua.g, vp.La.i)
          // (vp.Ya.i, vp.Sa.i) ........... (vp.Ya.i, vp.Sa.j)
          let _distance = this.computeDistanceBetween(this.geopointToGmapLatLng(this.gmapPopup.position),this.geopointToGmapLatLng(this.pageDevice.locationInfo.geometry.location));

          let _viewPortDistance = this.computeDistanceBetween(this.geopointToGmapLatLng(this.pageDevice.locationInfo.geometry.viewport[0]),this.geopointToGmapLatLng(this.pageDevice.locationInfo.geometry.viewport[1]));

          let _isInside = this.geopointIsInsideViewPort(this.gmapPopup.position, this.pageDevice.locationInfo.geometry.viewport);

          if(!_isInside || _distance >= 100 || _viewPortDistance >= 10000) {
            this.pageDevice.locationInfo = null
          }
        }
      }

      let toUpdateDevice = {
        name: this.pageDevice.name,
        admin: this.pageDevice.admin,
        photoURL: this.pageDevice.photoURL,
        description: this.pageDevice.description,
        lastModified: firebase.firestore.FieldValue.serverTimestamp(),
        active: this.pageDevice.active,
        macAddress: this.pageDevice.macAddress,
        useMacAddress: this.pageDevice.useMacAddress,
        useSensorsResponse: this.pageDevice.useSensorsResponse,
        location: this.pageDevice.location,
        locationZoom: this.pageDevice.locationZoom,
        locationPopupFontSize: this.pageDevice.locationPopupFontSize,
        locationInfo: this.pageDevice.locationInfo,
        relayTo: this.pageDevice.relayTo,
        relayToMethod: this.pageDevice.relayToMethod,
        relayToCustomURL: this.pageDevice.relayToCustomURL
      };

      let updateChildren = false;
      let toUpdateChildren = {};

      if(this.oldInherit == null || this.oldInherit != this.pageDevice.inherit) {
        updateChildren = true;
        toUpdateDevice.inherit = this.pageDevice.inherit;
        toUpdateChildren.inherit = this.pageDevice.inherit;
      }

      if(this.oldOpen == null || this.oldOpen != this.pageDevice.open) {
        updateChildren = true;
        toUpdateDevice.open = this.pageDevice.open;
        toUpdateChildren.open = this.pageDevice.open;
      }

      if(this.oldAdmin == null || this.oldAdmin != this.pageDevice.admin) {
        updateChildren = true;
        toUpdateDevice.admin = this.pageDevice.admin;
        toUpdateChildren.admin = this.pageDevice.admin;
      }

      if(this.oldFrApp == null || this.oldFrApp.length != this.pageDevice.frApp.length || this.oldFrApp.some((item,index)=> {
        if(item != this.pageDevice.frApp[index]) return true;
        else return false;
      })) {
        updateChildren = true;
        toUpdateDevice.frApp = this.pageDevice.frApp;
        toUpdateDevice.frAppCache = this.pageDevice.frAppCache;
        toUpdateChildren.frApp = this.pageDevice.frApp;
        toUpdateChildren.frAppCache = this.pageDevice.frAppCache;
      }

      this.submitDisabled = true
      this.showUpdateSpinner = true

      window.setTimeout(() => {
        this.submitDisabled = false
        this.showUpdateSpinner = false
      }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);

      let batch = db.batch();
      batch.update(db.collection("devices").doc(this.pageDevice.id), toUpdateDevice);
      if(updateChildren) {
        for(let sensorName in this.pageDevice.sensors) {
          batch.update(db.collection("sensors").doc(this.pageDevice.sensors[sensorName].id), toUpdateChildren);
        }
      }

      if(this.pageDevice.macAddress != "") {
        this.get("/app/existMac?mac=" + encodeURIComponent(this.pageDevice.macAddress) + "&device=" + encodeURIComponent(this.pageDevice.id))
        .then(result => {
          if(result.status != 200) {
            this.submitDisabled = false
            this.showUpdateSpinner = false
            this.makeToast("danger", "MAC 주소 조회 에러", "상태코드 " + result.status + ", 상태 메시지 " + result.statusText +"인 에러가 발생해서 MAC 주소 조회를 못했습니다. 기기 정보를 저장할 수 없습니다.", {
              "autoHideDelay": 3000
            })
            window.document.getElementById("deviceMacAddress").focus();
          }
          else {
            if(result.data == "0" || result.data == "1") {

              batch.commit()
              .then(()=>{
                this.submitDisabled = false
                this.showUpdateSpinner = false

                this.oldAdmin = this.pageDevice.admin;
                this.oldInherit = this.pageDevice.inherit;
                this.oldOpen = this.pageDevice.open;
                this.oldFrApp = this.pageDevice.frApp.concat([]);

                this.makeToast("success", "[" + this.pageDevice.name + "] 기기 정보 수정 성공", "기기 정보를 변경했습니다.", {
                  "autoHideDelay": 3000
                })
              })
              .catch(error => {
                this.submitDisabled = false
                this.showUpdateSpinner = false
                this.makeToast("danger", "[" + this.pageDevice.name + "] 기기 정보 수정 실패", "다음과 같은 에러가 발생했습니다.\n에러 내용:" + error.message, {
                  "autoHideDelay": 3000
                })
              })

            }
            else {
              this.submitDisabled = false
              this.showUpdateSpinner = false
              this.makeToast("danger", "MAC 주소 조회 에러", "동일한 MAC 주소가 이미 사용중입니다.", {
                "autoHideDelay": 3000
              })
            }
          }
        })
        .catch(error => {
          this.submitDisabled = false
          this.showUpdateSpinner = false
          this.makeToast("danger", "기기 삭제 실패.", "서버로 요청을 보내지 못했습니다. 에러 내용:" + error, {
            "autoHideDelay": 3000
          })
        })
      }
      else {

        batch.commit()
        .then(()=>{
          this.submitDisabled = false
          this.showUpdateSpinner = false

          this.oldAdmin = this.pageDevice.admin;
          this.oldInherit = this.pageDevice.inherit;
          this.oldOpen = this.pageDevice.open;
          this.oldFrApp = this.pageDevice.frApp.concat([]);

          this.makeToast("success", "[" + this.pageDevice.name + "] 기기 정보 수정 성공", "기기 정보를 변경했습니다.", {
            "autoHideDelay": 3000,
          })
        })
        .catch(error => {
          this.submitDisabled = false
          this.showUpdateSpinner = false
          this.makeToast("danger", "[" + this.pageDevice.name + "] 기기 정보 수정 실패", "다음과 같은 에러가 발생했습니다.\n에러 내용:" + error.message, {
            "autoHideDelay": 3000
          })
        })
      }
    },
  },
  computed: {
    pageDeviceSensorsLength: function() {
      return this.countAttributes(this.pageDevice.sensors);
    },
    totalDataRowCount: function() {
        var count = 0
        for(let item in this.pageDevice.sensors) {
          count += this.pageDevice.sensors[item].lastBook*1000 + this.pageDevice.sensors[item].lastIndex + 1
        }
        return count
    },
    totalDataCellCount: function() {
        var count = 0
        for(var item in this.pageDevice.sensors) {
          if(this.pageDevice.sensors[item].lastValues != null) {
            count+= (this.pageDevice.sensors[item].lastBook*1000 + this.pageDevice.sensors[item].lastIndex + 1)* this.pageDevice.sensors[item].lastValues.v.length
          }
        }
        return count;
        // string: 4x길이+1 byte
        // boolean: 1 byte
        // number: 8 byte
        // geopoint: 16 byte
        // datetime 8byte
    },
    totalDataCellByteCount: function() {
        var count = 0
        for(var item in this.pageDevice.sensors) {
          var rowCount = this.pageDevice.sensors[item].lastBook*1000 + this.pageDevice.sensors[item].lastIndex + 1
          if(this.pageDevice.sensors[item].lastValues != null) {
            var rowSize = (4*1+1)*2
            this.pageDevice.sensors[item].lastValues.v.forEach(function(vItem) {
              if(typeof(vItem) == "boolean") {
                rowSize += 1
              }
              else if(typeof(vItem) == "string") {
                rowSize += 4*8+1
              }
              else if(vItem === null) {
                rowSize += 1
              }
              else {
                rowSize += 8
              }
            })
            count+= rowCount*rowSize
          }
        }
        return Math.ceil(count/1024/1024*1000)/1000
    },
    markerPosition: function() {
      if(this.pageDevice.location != null) {
        return {
          lat: this.pageDevice.location.latitude,
          lng: this.pageDevice.location.longitude
        }
      }
      else {
        return {lat:37.545576, lng:126.959690}
      }
    },
    google: gmapApi
  },
}
</script>
